var map = {
	"./orders.billings.js": "./src/router/admin/orders.billings.js",
	"./orders.customers.js": "./src/router/admin/orders.customers.js",
	"./orders.detail-statuses.js": "./src/router/admin/orders.detail-statuses.js",
	"./orders.reports.js": "./src/router/admin/orders.reports.js",
	"./orders.statuses.js": "./src/router/admin/orders.statuses.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router/admin sync orders(?!\\.route)\\.[a-z-]+(\\.js$)";